export default __webpack_public_path__ + "static/media/solanaDropdown.2d2fe2f5.svg";